import { AxiosResponse } from "axios";
import get from "lodash-es/get";

import api from "app/api/requests/PageContent";
import getToken from "app/api/getToken";
import { IPageContent } from "app/api/types";

export const GET_PAGE_CONTENT_BY_ID_REQUEST = "GET_PAGE_CONTENT_BY_ID_REQUEST";
export const GET_PAGE_CONTENT_BY_ID_SUCCESS = "GET_PAGE_CONTENT_BY_ID_SUCCESS";
export const GET_PAGE_CONTENT_BY_ID_FAIL = "GET_PAGE_CONTENT_BY_ID_FAIL";

export const getPageContentById = (id: IPageContent["pageId"]) => (
  dispatch: any
): any => {
  dispatch({ type: GET_PAGE_CONTENT_BY_ID_REQUEST });

  const token = getToken();

  return api
    .getPageContentById(token, id)
    .then((response: AxiosResponse) => {
      const pageContent: IPageContent[] = get(response, "data", {});
      dispatch({ type: GET_PAGE_CONTENT_BY_ID_SUCCESS, payload: pageContent });

      return pageContent;
    })
    .catch(err => {
      dispatch({
        type: GET_PAGE_CONTENT_BY_ID_FAIL
      });
      throw get(err, "response.data.errors", {});
    });
};
